import { capitalize } from 'radash';

export const normalizeSeverityLabel = (severity: string): string => {
  if (!severity) {
    return '';
  }

  return capitalize(severity.toLowerCase());
};
